// lodash
import find from 'lodash/find';

import stripWhitespace from '../../string/stripWhitespace';
import supportedCreditCardTypes from '../../../constants/supportedCreditCardTypes';

export function getCardNumberInputClassName(cardType) {
  const isSupportedCardType = find(supportedCreditCardTypes, supportedCard => supportedCard === cardType);
  const formattedCardType = isSupportedCardType ? stripWhitespace(cardType) : '';
  return `cardNumberField${formattedCardType}`;
}

export function getCvvClassName(cardType) {
  if (!cardType) {
    return 'securityCodeField';
  }

  return (cardType === supportedCreditCardTypes.AMERICAN_EXPRESS)
    ? 'securityCodeFieldAmex' : 'securityCodeFieldNonAmex';
}
